module.exports = __webpack_public_path__ + "assets/img/17.4ef03ffb.png";